import { signIn } from 'next-auth/react';
import {
  Alert,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from '@mui/material';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { useAppDispatch } from '../../../pages/assessment';
import { updateMeta } from '../../../redux/meta';
import { setPatient } from '../../../redux/assessment';
import StyledExternalLink from '../shared/privacy-policy-link';
import { withDataPoint } from '../../../diagnostics/client';
import {
  AssessmentButtons,
  AssessmentCard,
  ControlledTextField,
} from '../shared';
import { rules } from '../demographics/rules';

interface FormValues {
  email: string;
  isPolicyAcknowledged: boolean;
}

const CollectEmail = () => {
  const dispatch = useAppDispatch();

  const checkboxLabel = (
    <>
      I agree to Talkiatry’s{' '}
      <StyledExternalLink
        url="https://www.talkiatry.com/privacy-policy"
        text="Privacy Policy"
      />{' '}
      and{' '}
      <StyledExternalLink
        url="https://www.talkiatry.com/terms-of-use"
        text="Terms of Use"
      />
    </>
  );

  const {
    control,
    handleSubmit,
    formState: { isValid, isSubmitting },
  } = useForm<FormValues>({
    mode: 'onBlur',
  });

  const onSubmit: SubmitHandler<FormValues> = async data => {
    const { email } = data;
    await withDataPoint('intake__patient_auth__submit_email', async dp => {
      dp.email = email;
      void signIn('email', { email, redirect: false });
    });
    dispatch(setPatient({ email }));
    dispatch(updateMeta());
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <AssessmentCard>
        <Alert severity="info">
          If you're seeking care for a minor, enter your email as the legal
          guardian.
        </Alert>
        <ControlledTextField<FormValues>
          name="email"
          control={control}
          rules={rules.email}
          label="Email"
          defaultValue=""
          autoComplete="on"
          sx={{ mt: 3 }}
        />
        <Controller
          name="isPolicyAcknowledged"
          control={control}
          defaultValue={false}
          rules={rules.isPolicyAcknowledged as any}
          render={({ field, fieldState }) => (
            <FormControl error={!!fieldState.error} sx={{ mt: 2 }}>
              <FormControlLabel
                control={<Checkbox {...field} />}
                label={checkboxLabel}
              />
              {fieldState.error && (
                <FormHelperText>{fieldState.error.message}</FormHelperText>
              )}
            </FormControl>
          )}
        />
      </AssessmentCard>
      <AssessmentButtons
        primary={{
          children: 'Continue',
          type: 'submit',
          disabled: !isValid || isSubmitting,
          loading: isSubmitting,
        }}
      />
    </form>
  );
};

export default CollectEmail;
